import { ChevronDown } from 'lucide-react';
import workoutLoggerMockup from '../../../shared/assets/mockups/WorkoutLogger.webp';
import appStoreBadge from '../../../shared/assets/badges/app-store-badge.svg';
import googlePlayBadge from '../../../shared/assets/badges/goole-play-badge.svg';
import './HeroSection.css';

const APP_STORE_URL = 'https://apps.apple.com/app/id6752858463';
const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.liftpeak.app';

export function HeroSection() {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">Turn every session into progress</h1>
          <p className="hero-subtitle">
            LiftPeak combines fast workout logging, clear analytics, routines, and a welcoming community to help you stay consistent.
          </p>
          <div className="hero-cta-group">
            <div className="store-badges">
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge-link"
              >
                <img src={appStoreBadge} alt="Download on the App Store" className="store-badge" />
              </a>
              <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge-link"
              >
                <img src={googlePlayBadge} alt="Get it on Google Play" className="store-badge" />
              </a>
            </div>
            <p className="store-tagline">Join growing community of consistent lifters</p>
          </div>

          {/* Scroll indicator - mobile only */}
          <div className="scroll-indicator">
            <ChevronDown size={24} strokeWidth={1.5} />
            <ChevronDown size={24} strokeWidth={1.5} />
          </div>
        </div>

        <div className="hero-mockup">
          <img 
            src={workoutLoggerMockup} 
            alt="Liftpeak workout logging interface" 
            className="hero-mockup-image"
          />
        </div>
      </div>
    </section>
  );
}

export default HeroSection;


